import angular from 'angular';

import AbsoluteNumber from './absolute-number.filter/absoluteNumber';
import GroupByCustom from './groupBy.filter/groupBy.filter';
import FirstKey from './key-value.filter/firstKey';
import FirstValue from './key-value.filter/firstValue';
import Keys from './key-value.filter/keys';
import MatchIds from './match-ids.filter/matchIds';
import {
    TnStoreTypeaheadConfig,
    populateTemplateCache,
} from './typeahead-template-override.decorator/typeaheadTemplateOverride';

export default angular
    .module('tn.core', ['ui.router', 'ui.bootstrap'])
    // providers
    .filter('groupBy', GroupByCustom)
    .filter('tnAbsoluteNumber', AbsoluteNumber)
    .filter('tnFirstKey', FirstKey)
    .filter('tnFirstValue', FirstValue)
    .filter('tnKeys', Keys)
    .filter('tnMatchIds', MatchIds)
    // bootstrap
    .config(TnStoreTypeaheadConfig)
    .run(populateTemplateCache)
    .name;
